import { writable } from 'svelte/store';

const defaultLanguage = 'en';

// Initialize the store with the saved language or default
const initialLanguage = typeof window !== 'undefined'
  ? window.localStorage.getItem('language') || defaultLanguage 
  : defaultLanguage;

export const language = writable(initialLanguage);

// Subscribe to changes and update localStorage
if (typeof window !== 'undefined') {
  language.subscribe(value => {
    window.localStorage.setItem('language', value);
  });
}